<div class="table-list" class="w-100">
    <div>
        <mat-spinner *ngIf="dataSource['loading$'] | async" [diameter]="30" style="margin:0 auto"></mat-spinner>
    </div>
    <table mat-table #table [dataSource]="dataSource" class="w-100" [hidden]="dataSource['error$'] | async">

        <ng-content></ng-content>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i= index;" (click)="selectRow(row, i)"
            [style.background]="selectedRowIndex === i ? '#eee' : ''">
        </tr>
    </table>

    <mat-card class="no-results" [hidden]="dataSource['error$'] | async" *ngIf="(!(dataSource['loading$'] | async) 
                        && (!(dataSource['error$'] | async)) && (dataSource['total'] === 0)) 
                        || (dataSource['total'] == 0)">
        <div>{{ noResultMessage }}</div>
    </mat-card>

    <mat-card class="no-results" *ngIf="dataSource['error$'] | async">
        <div>The service is temporary unavailable, please try again later.</div>
    </mat-card>

    <mat-paginator #paginator [pageSize]="defaultPageSize" [pageSizeOptions]="[5, 10, 25, 50]" [hidden]="dataSource['total'] === 0"
        [length]="dataSource['total']"></mat-paginator>
</div>